
import { Record, Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, option_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { ClientTypes_Route, ClientTypes_Route_$reflection } from "../ClientTypes.js";
import { FloodReliefCopy_shareDescription } from "../FloodReliefCopy.js";

export class BodyH1Mode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SystemTitleDropped", "UserContentKept"];
    }
}

export function BodyH1Mode_$reflection() {
    return union_type("Shared.PageMeta.BodyH1Mode", [], BodyH1Mode, () => [[], []]);
}

export class PillMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Pill", "Suppressed", "NoChrome"];
    }
}

export function PillMode_$reflection() {
    return union_type("Shared.PageMeta.PillMode", [], PillMode, () => [[["text", string_type]], [], []]);
}

export class PageMetaEntry extends Record {
    constructor(Title, Parent, BodyH1) {
        super();
        this.Title = Title;
        this.Parent = Parent;
        this.BodyH1 = BodyH1;
    }
}

export function PageMetaEntry_$reflection() {
    return record_type("Shared.PageMeta.PageMetaEntry", [], PageMetaEntry, () => [["Title", PillMode_$reflection()], ["Parent", option_type(ClientTypes_Route_$reflection())], ["BodyH1", BodyH1Mode_$reflection()]]);
}

/**
 * The navigation item a route belongs to, for nav active state. Variants of a
 * page (such as create with a preselected charity) map to that page's route.
 */
export function navRoute(route) {
    if (route.tag === 4) {
        return new ClientTypes_Route(3, []);
    }
    else {
        return route;
    }
}

/**
 * Look up the page metadata for a route. The Anonymous-Home case is handled
 * by the caller via `lookupForAuth` because the result depends on Auth state.
 */
export function lookup(route) {
    switch (route.tag) {
        case 1:
            return new PageMetaEntry(new PillMode(0, ["Support Others"]), undefined, new BodyH1Mode(0, []));
        case 2:
            return new PageMetaEntry(new PillMode(0, ["Challenge"]), new ClientTypes_Route(1, []), new BodyH1Mode(1, []));
        case 3:
        case 4:
            return new PageMetaEntry(new PillMode(0, ["Create"]), new ClientTypes_Route(0, []), new BodyH1Mode(0, []));
        case 5:
            return new PageMetaEntry(new PillMode(0, ["Profile"]), new ClientTypes_Route(0, []), new BodyH1Mode(0, []));
        case 6:
            return new PageMetaEntry(new PillMode(0, ["Complete Profile"]), new ClientTypes_Route(0, []), new BodyH1Mode(0, []));
        case 8:
            return new PageMetaEntry(new PillMode(0, ["Sign Up"]), new ClientTypes_Route(0, []), new BodyH1Mode(0, []));
        case 9:
            return new PageMetaEntry(new PillMode(0, ["Verify Email"]), new ClientTypes_Route(8, []), new BodyH1Mode(0, []));
        case 10:
            return new PageMetaEntry(new PillMode(0, ["Pledge"]), new ClientTypes_Route(1, []), new BodyH1Mode(1, []));
        case 11:
            return new PageMetaEntry(new PillMode(0, ["Supporters"]), new ClientTypes_Route(2, [route.fields[0]]), new BodyH1Mode(0, []));
        case 12:
            return new PageMetaEntry(new PillMode(0, ["Daily Logs"]), new ClientTypes_Route(2, [route.fields[0]]), new BodyH1Mode(1, []));
        case 13:
            return new PageMetaEntry(new PillMode(0, ["Privacy"]), new ClientTypes_Route(0, []), new BodyH1Mode(0, []));
        case 14:
            return new PageMetaEntry(new PillMode(0, ["Terms"]), new ClientTypes_Route(0, []), new BodyH1Mode(0, []));
        case 15:
            return new PageMetaEntry(new PillMode(0, ["Refunds"]), new ClientTypes_Route(0, []), new BodyH1Mode(0, []));
        case 16:
            return new PageMetaEntry(new PillMode(0, ["Flood Relief"]), new ClientTypes_Route(0, []), new BodyH1Mode(1, []));
        case 7:
            return new PageMetaEntry(new PillMode(2, []), undefined, new BodyH1Mode(0, []));
        default:
            return new PageMetaEntry(new PillMode(0, ["Home"]), undefined, new BodyH1Mode(0, []));
    }
}

/**
 * Auth-aware lookup. Anonymous Home suppresses the pill; everything else uses `lookup`.
 */
export function lookupForAuth(auth, route) {
    let matchResult;
    if (route.tag === 0) {
        if (auth.tag === 0) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new PageMetaEntry(new PillMode(1, []), undefined, new BodyH1Mode(0, []));
        default:
            return lookup(route);
    }
}

/**
 * The HTML document title. Legal pages name themselves so a crawler or reviewer
 * fetching the raw HTML can identify them; every other route keeps the site-wide title.
 * Shared by the server's SSR `<title>` and the client's post-hydration route changes
 * so the two paths cannot drift apart.
 */
export function documentTitle(route) {
    switch (route.tag) {
        case 13:
            return "Privacy Notice - You-thon";
        case 14:
            return "Terms of Service - You-thon";
        case 15:
            return "Refund Policy - You-thon";
        case 16:
            return "Flood Relief Challenges - You-thon";
        default:
            return "You-thon - Motivation for good.";
    }
}

/**
 * The meta description and link-preview (Open Graph) summary. Only pages meant to be
 * shared have one; the SSR head emits description and Open Graph tags only when it is Some.
 */
export function documentDescription(route) {
    if (route.tag === 16) {
        return FloodReliefCopy_shareDescription;
    }
    else {
        return undefined;
    }
}

//# sourceMappingURL=PageMeta.js.map
